import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import { isDeviceKeyValid } from '../common/keyValidation';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import { showModalMessage } from '../store/modalsSlice';

import DeviceKeyInputNormalized from '../components/deviceKeyInputNormalized';
import { unwrapResult } from '@reduxjs/toolkit';

class ReactivatePermanentLicenseDialog extends Component {
  initState = {
    deviceKey: ''
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onClose = this.onClose.bind(this);
    this.onKeyChanged = this.onKeyChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onKeyChanged(normalizedValue) {
    this.setState({ deviceKey: normalizedValue });
  }

  isSubmitButtonDisabled() {
    return !this.isCorrectDeviceKey();
  }

  isCorrectDeviceKey() {
    return isDeviceKeyValid(this.state.deviceKey.trim()) &&
      this.state.deviceKey !== this.props.deviceKey;
  }

  onSubmit() {
    const { licenseId } = this.props;
    const { deviceKey } = this.state;
    this.onClose();
    this.props.reactivate({ licenseId, deviceKey }).then(unwrapResult).catch(() => {
      this.props.showModalMessage("Error", this.props.error.toString())
    });
  }

  renderStatic() {
    return <React.Fragment>
      <FormGroup controlId="fcLicenseKey">
        <FormControl.Static>License key <strong>{this.props.licenseKey}</strong></FormControl.Static>
      </FormGroup>
      <FormGroup controlId="fcDeviceKey">
        <ControlLabel>Device key</ControlLabel>
        <DeviceKeyInputNormalized onChange={this.onKeyChanged}/>
      </FormGroup>
    </React.Fragment>
  }

  renderDeviceKeyError() {
    let message = this.state.deviceKey.length === 0 ? {
      text: "Enter device key",
      className: "text-info"
    } : (
      this.state.deviceKey === this.props.deviceKey ? {
        text: "License is already activated with this device key",
        className: "text-danger"
      } : {
        text: "Device key is not correct",
        className: "text-danger"
      }
    );
    return <FormControl.Static className={message.className}>{message.text}</FormControl.Static>;
  }

  renderDynamic() {
    return !this.isCorrectDeviceKey() ?
      this.renderDeviceKeyError() :
      null;
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>Reactivate permanent license</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderStatic()}
          {this.renderDynamic()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            Reactivate
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  error: permanentLicensesSelectors.creatingUpdatingChangingError(state),
});

const actionCreators = {
  reactivate: permanentLicensesActions.reactivate,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(ReactivatePermanentLicenseDialog);



// WEBPACK FOOTER //
// ./src/containers/reactivatePermanentLicenseDialog.js